import styled from 'styled-components';

export const StyledPurchaseContainer = styled.div`
  @media only screen and (max-width: ${({ theme }) =>
      theme.BP.PURCHASE_MOBILE_WIDTH}) {
    margin: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.COLORS.BASE};
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.PURCHASE_DESKTOP_XLARGE_WIDTH}) {
    margin: 30px auto;
    width: ${({ theme }) => theme.BP.PURCHASE_MAX_WIDTH};
  }
`;

export default {};
